import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const buyers = [{
  name: 'Ana G.',
  location: 'Madrid, España',
  time: 'hace 3 minutos'
}, {
  name: 'Roberto M.',
  location: 'Ciudad de México',
  time: 'hace 7 minutos'
}, {
  name: 'Claudia P.',
  location: 'Buenos Aires, Argentina',
  time: 'hace 12 minutos'
}, {
  name: 'Fernando L.',
  location: 'Bogotá, Colombia',
  time: 'hace 18 minutos'
}, {
  name: 'Patricia S.',
  location: 'Lima, Perú',
  time: 'hace 25 minutos'
}, {
  name: 'Miguel A.',
  location: 'Santiago, Chile',
  time: 'hace 32 minutos'
}, {
  name: 'Laura R.',
  location: 'Miami, USA',
  time: 'hace 41 minutos'
}, {
  name: 'Diego V.',
  location: 'Barcelona, España',
  time: 'hace 48 minutos'
}];
export function SocialProofToasts() {
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const initialDelay = setTimeout(() => {
      setCurrentIndex(0);
      setIsVisible(true);
    }, 8000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (currentIndex < 0) return;
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 4000);
    const nextTimer = setTimeout(() => {
      const nextIndex = currentIndex + 1;
      if (nextIndex < buyers.length) {
        setCurrentIndex(nextIndex);
        setIsVisible(true);
      }
    }, 15000 + Math.random() * 10000);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, [currentIndex]);
  const buyer = currentIndex >= 0 ? buyers[currentIndex] : null;
  return <AnimatePresence data-id="element-165">
      {isVisible && buyer && <motion.div key={currentIndex} initial={{
      opacity: 0,
      x: -80,
      y: 0
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -80
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-5 left-5 z-50 max-w-[280px]" data-id="element-166">
          <div className="bg-white rounded-xl px-4 py-3 shadow-[0_8px_30px_rgba(0,0,0,0.12)] border border-gray-100 flex items-center gap-3" data-id="element-167">
            <div className="w-9 h-9 rounded-full bg-[#38A169] flex items-center justify-center text-white text-sm font-bold flex-shrink-0" data-id="element-168">
              ✓
            </div>
            <div className="min-w-0" data-id="element-169">
              <p className="text-xs font-bold text-[#1A2744] truncate" data-id="element-170">
                {buyer.name} compró la guía
              </p>
              <p className="text-[11px] text-[#718096] truncate" data-id="element-171">
                {buyer.location} · {buyer.time}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}